import { Flexbox } from '@components/styles/mixins/Flexbox.styled';
import styled from 'styled-components';

export const Contact = styled.section`
    position:fixed;
    top:0;
    left:0;
    width:100%;
    height:100%;
    z-index:3;
    background:rgba(255,255,255,0.5);
    ${Flexbox({justifyContent:"center", alignItems:'center', flexDirection:'column'})};
    row-gap:1.5rem;
    .modal{
        padding:3rem;
        font-size:3rem;
        background:yellow;
    }
`;

export const SBottomContactUs  = styled.article`
    .contact-us-container{
        padding:1rem;
        z-index:10000000;
        padding-bottom:2.3rem;
        color:${({ theme }) => theme.colors.emerald30};
    }
`;